import * as React from 'react'
import { SVGProps, memo } from 'react'

const AppIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={21}
    height={18}
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M8.183.628a1.513 1.513 0 0 0-.385.267c-.298.327-.4.81-.257 1.206.044.12.39.728.77 1.35L9 4.583 7.608 6.878l-1.99 3.285-.6.989-1.721-.006c-1.102-.004-1.771.008-1.86.035a1.463 1.463 0 0 0-.844.694c-.078.14-.093.23-.093.547 0 .421.038.524.3.802.298.319.334.326 1.686.357.66.015 3.366.04 6.013.056 4.03.024 4.82.02 4.85-.026.057-.085.042-.548-.027-.827-.136-.559-.573-1.096-1.163-1.43l-.297-.167H9.958c-1.173 0-1.913-.015-1.928-.039-.02-.031 1.346-2.308 4.858-8.09.539-.887.534-.878.583-1.126.105-.533-.194-1.076-.732-1.33-.194-.091-.26-.101-.562-.088-.397.017-.66.122-.874.35-.072.078-.28.387-.462.689-.181.3-.342.547-.357.547-.015 0-.174-.243-.352-.541-.368-.616-.55-.818-.855-.955a1.352 1.352 0 0 0-1.094.024Zm4.281 5.025c-.169.26-.616 1.007-.712 1.19-.325.617-.35 1.486-.06 2.136.04.09.888 1.508 1.883 3.149l2.372 3.913c.31.512.62.997.693 1.078.071.081.239.2.372.264.207.1.29.116.573.116.277 0 .365-.017.542-.106.562-.28.843-.901.665-1.468-.03-.097-.337-.638-.68-1.202l-.625-1.026h.962c1.098 0 1.263-.028 1.584-.273.4-.304.562-.83.411-1.331-.087-.29-.392-.62-.697-.752-.217-.094-.225-.095-1.986-.107l-1.767-.012-.226-.366c-.124-.202-.889-1.46-1.7-2.798-.81-1.337-1.489-2.446-1.508-2.465-.02-.018-.062.009-.096.06ZM3.8 14.23c-.31.076-.714.278-.864.431-.157.16-.636.94-.744 1.211-.186.467-.015 1.054.4 1.37.261.199.446.258.804.258.36 0 .64-.112.88-.348.096-.095.464-.654.851-1.293l.683-1.126-.194-.106-.324-.18c-.389-.221-1.071-.32-1.492-.217Z'
      clipRule='evenodd'
    />
  </svg>
)

const Memo = memo(AppIcon)
export default Memo
